<template>
  <el-form ref="ff" v-loading="loading" :model="module">
    <el-row :gutter="20">
      <el-col>
        <el-form-item label="菜单名称" prop="Title">
          <el-input v-model="module.Title">
            <el-switch slot="append" v-model="module.State" active-text="显示" />
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="上级菜单">
          <el-cascader
            res="parentId"
            v-model="module.ParentId"
            :options="parentOptions"
            :props="{
              value: 'Id',
              label: 'Title',
              checkStrictly: true,
              emitPath: false,
            }"
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="字体图标">
          <el-input v-model="module.Icon" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="部件">
          <el-input v-model="module.Component" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="路径" prop="Path">
          <el-input v-model="module.Path" placeholder="Path" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="重定向">
          <el-input v-model="module.Redirect" placeholder="Redirect" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="排序号" prop="Sort">
          <el-input v-model="module.Sort" placeholder="正序排列" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="module = {}">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      module: {},
      btns: [],
      parentOptions: [],
    }
  },
  props: {
    id: { type: String, default: null },
    layerid: { type: String, default: null }
  },
  created () {
    this.initParents()
    this.loadData()
  },
  methods: {
    //获取数据对象
    loadData () {
      if (this.id) {
        this.$apis.system.menu.getData({ id: this.id }).then(res => {
          this.module = res
        })
      }
    },
    //获取上级树
    initParents () {
      this.$apis.system.menu.getTree({
        parentId: null,
        state: null
      }).then(res => {
        this.parentOptions = res
      })
    },
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.system.menu.submit(this.module).then(() => {
            this.$parent.loadData()
            this.$layer.close(this.layerid)
            this.$message({ message: "数据提交成功！", type: "success" })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
};
</script>
